import React from 'react';
import {connect} from 'react-redux';
import * as pcSelectors from '../product-configurator/selectors';
import * as a from "./actions";
import {ConfirmationDialog} from "../../components/confirmation-dialog/views";
import * as s from "./selectors";
import './reducers';

function PizzaContainsOnlyDoughDialogBody({title}) {
    return (
            <p>
                <strong>{title}</strong>
            </p>
    );
}

const PizzaContainsOnlyDoughDialog = connect(
    (state, ownProps) => ({
        showPizzaContainsOnlyDough: s.showPizzaContainsOnlyDough(state),
        texts: s.pizzaContainsOnlyDoughDialog(state),
    }),
    (dispatch, ownProps) => ({
        cancel: () => dispatch(a.hidePizzaContainsOnlyDough()),
        confirm: () => {
            dispatch(a.hidePizzaContainsOnlyDough());
            dispatch(a.sendConfiguratorForm());
        },
    })
)(({showPizzaContainsOnlyDough, cancel, confirm, texts}) => {
    return showPizzaContainsOnlyDough ? (
        <ConfirmationDialog
            message={
                <PizzaContainsOnlyDoughDialogBody
                    title={texts.title}
                />
            }
            confirmLabel={texts.confirm}
            cancelLabel={texts.cancel}
            onCancel={cancel}
            onConfirm={confirm}
        />
    ) : null;
});

function PizzaContainsNoMozzarellaDialogBody({title, body}) {
    return (
        <React.Fragment>
            <p>
                <strong>{title}</strong>
            </p>
            <p>
                {body}
            </p>
        </React.Fragment>
    );
}

const PizzaContainsNoMozzarellaDialog = connect(
    (state, ownProps) => ({
        showPizzaContainsNoMozzarella: s.showPizzaContainsNoMozzarella(state),
        texts: s.pizzaContainsNoMozzarellaDialog(state),
    }),
    (dispatch, ownProps) => ({
        cancel: () => {
            dispatch(a.hidePizzaContainsNoMozzarella());
            dispatch(a.sendConfiguratorForm());
        },
        confirm: () => {
            dispatch(a.hidePizzaContainsNoMozzarella());
            dispatch(a.addMozzarella());
        },
    })
)(({showPizzaContainsNoMozzarella, cancel, confirm, texts}) => {
    return showPizzaContainsNoMozzarella ? (
        <ConfirmationDialog
            message={
                <PizzaContainsNoMozzarellaDialogBody
                    title={texts.title}
                    body={texts.body}
                />
            }
            confirmLabel={texts.confirm}
            cancelLabel={texts.cancel}
            onCancel={cancel}
            onConfirm={confirm}
        />
    ) : null;
});

export const ProductConfiguratorSubmit = connect(
    (state, ownProps) => ({
        text: pcSelectors.productConfiguratorSubmit(state).text,
        showNoShipmentModal: pcSelectors.productConfiguratorSubmit(state).showNoShipmentModal,
    }),
    (dispatch, ownProps) => ({
        onSubmit: (event) => {
            dispatch(a.submit(event));
        },
    })
)(
    ({
        text, showNoShipmentModal,
        onSubmit
     }) => {
        return (
            <React.Fragment>
                <PizzaContainsOnlyDoughDialog />
                <PizzaContainsNoMozzarellaDialog />
                <button type="submit" className="product__cart btn btn--active btn--block" data-modal={showNoShipmentModal} onClick={ showNoShipmentModal ? false : onSubmit }>
                    {text}
                </button>
            </React.Fragment>
        );
    }
);
